var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorKyteTecState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apo_Icon_02_Fehler",
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.405,
    height: 179.141,
    viewBox: "0 0 248.405 179.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2488",
    "data-name": "Gruppe 2488",
    transform: "translate(20.984 150.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2487",
    "data-name": "Gruppe 2487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3527",
    "data-name": "Pfad 3527",
    d: "M-1516.423,518.458a2.106,2.106,0,0,1-2.107-2.107V491.9a2.107,2.107,0,0,1,2.107-2.107,2.107,2.107,0,0,1,2.107,2.107v24.45A2.105,2.105,0,0,1-1516.423,518.458Z",
    transform: "translate(1518.529 -489.795)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2489",
    "data-name": "Gruppe 2489",
    transform: "translate(8.758 162.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3528",
    "data-name": "Pfad 3528",
    d: "M-1496.326,498.36h-24.45a2.105,2.105,0,0,1-2.107-2.107,2.107,2.107,0,0,1,2.107-2.107h24.45a2.107,2.107,0,0,1,2.107,2.107A2.105,2.105,0,0,1-1496.326,498.36Z",
    transform: "translate(1522.882 -494.147)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2491",
    "data-name": "Gruppe 2491",
    transform: "translate(197.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2490",
    "data-name": "Gruppe 2490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3529",
    "data-name": "Pfad 3529",
    d: "M-1453.418,442.975a2.1,2.1,0,0,1-1.491-.618,2.1,2.1,0,0,1,0-2.977l2.545-2.542a2.1,2.1,0,0,1,2.977,0,2.1,2.1,0,0,1,0,2.977l-2.542,2.542A2.1,2.1,0,0,1-1453.418,442.975Z",
    transform: "translate(1455.527 -436.22)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2492",
    "data-name": "Gruppe 2492",
    transform: "translate(187.897 10.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3530",
    "data-name": "Pfad 3530",
    d: "M-1457,446.553a2.1,2.1,0,0,1-1.489-.618,2.107,2.107,0,0,1,0-2.98l2.542-2.542a2.107,2.107,0,0,1,2.98,0,2.112,2.112,0,0,1,0,2.98l-2.545,2.542A2.1,2.1,0,0,1-1457,446.553Z",
    transform: "translate(1459.103 -439.796)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2493",
    "data-name": "Gruppe 2493",
    transform: "translate(197.941 10.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3531",
    "data-name": "Pfad 3531",
    d: "M-1450.876,446.552a2.1,2.1,0,0,1-1.489-.618l-2.545-2.542a2.1,2.1,0,0,1,0-2.977,2.107,2.107,0,0,1,2.98,0l2.542,2.539a2.107,2.107,0,0,1,0,2.98A2.1,2.1,0,0,1-1450.876,446.552Z",
    transform: "translate(1455.527 -439.797)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2497",
    "data-name": "Gruppe 2497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2494",
    "data-name": "Gruppe 2494",
    transform: "translate(187.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3532",
    "data-name": "Pfad 3532",
    d: "M-1454.452,442.975a2.1,2.1,0,0,1-1.491-.618l-2.542-2.542a2.1,2.1,0,0,1,0-2.977,2.107,2.107,0,0,1,2.98,0l2.542,2.542a2.1,2.1,0,0,1,0,2.977A2.089,2.089,0,0,1-1454.452,442.975Z",
    transform: "translate(1459.103 -436.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2495",
    "data-name": "Gruppe 2495",
    transform: "translate(0 121.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3533",
    "data-name": "Pfad 3533",
    d: "M-1517.74,495.825a8.268,8.268,0,0,1-8.261-8.258,8.269,8.269,0,0,1,8.261-8.26,8.27,8.27,0,0,1,8.26,8.26A8.27,8.27,0,0,1-1517.74,495.825Zm0-12.305a4.05,4.05,0,0,0-4.048,4.047,4.05,4.05,0,0,0,4.048,4.045,4.052,4.052,0,0,0,4.047-4.045A4.052,4.052,0,0,0-1517.74,483.52Z",
    transform: "translate(1526 -479.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2496",
    "data-name": "Gruppe 2496",
    transform: "translate(219.748 11.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3534",
    "data-name": "Pfad 3534",
    d: "M-1433.436,468.852a14.347,14.347,0,0,1-14.327-14.333,14.345,14.345,0,0,1,14.327-14.33,14.345,14.345,0,0,1,14.33,14.33A14.348,14.348,0,0,1-1433.436,468.852Zm0-24.45a10.128,10.128,0,0,0-10.114,10.117,10.131,10.131,0,0,0,10.114,10.12,10.13,10.13,0,0,0,10.117-10.12A10.127,10.127,0,0,0-1433.436,444.4Z",
    transform: "translate(1447.763 -440.189)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2498",
    "data-name": "Gruppe 2498",
    transform: "translate(90.726 54.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3535",
    "data-name": "Pfad 3535",
    d: "M-1488.31,527.224a5.38,5.38,0,0,1-3.811-1.576,5.389,5.389,0,0,1,0-7.62l27.017-27.014-26.3-26.34a5.386,5.386,0,0,1,0-7.617,5.389,5.389,0,0,1,7.62,0l26.3,26.335,25.624-25.624a5.389,5.389,0,0,1,7.62,0,5.389,5.389,0,0,1,0,7.62l-25.63,25.63,26.306,26.34a5.389,5.389,0,0,1-.005,7.62,5.386,5.386,0,0,1-7.617-.006l-26.3-26.338-27.009,27.012A5.376,5.376,0,0,1-1488.31,527.224Z",
    transform: "translate(1493.699 -455.48)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2503",
    "data-name": "Gruppe 2503",
    transform: "translate(50.821 15.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2499",
    "data-name": "Gruppe 2499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3536",
    "data-name": "Pfad 3536",
    d: "M-1432.486,592.551h-.183a74.914,74.914,0,0,1-53.279-22.223,74.931,74.931,0,0,1-21.959-53.388,75.514,75.514,0,0,1,75.423-75.241h.185a74.944,74.944,0,0,1,53.279,22.223,74.925,74.925,0,0,1,21.959,53.389,74.7,74.7,0,0,1-7.629,32.9,5.378,5.378,0,0,1-7.2,2.474,5.385,5.385,0,0,1-2.475-7.2,64,64,0,0,0,6.533-28.2,64.222,64.222,0,0,0-18.822-45.76,64.234,64.234,0,0,0-45.67-19.049h-.157a64.726,64.726,0,0,0-64.649,64.494,64.221,64.221,0,0,0,18.821,45.76,64.225,64.225,0,0,0,45.67,19.049h.155a64.234,64.234,0,0,0,37.334-11.861,5.384,5.384,0,0,1,7.51,1.281,5.389,5.389,0,0,1-1.281,7.511A74.938,74.938,0,0,1-1432.486,592.551Z",
    transform: "translate(1507.906 -441.699)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2502",
    "data-name": "Gruppe 2502",
    transform: "translate(0.731 14.667)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2501",
    "data-name": "Gruppe 2501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2500",
    "data-name": "Gruppe 2500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3537",
    "data-name": "Pfad 3537",
    d: "M-1437.863,586.485a69.78,69.78,0,0,0,69.78-69.781,69.781,69.781,0,0,0-69.78-69.783,69.783,69.783,0,0,0-69.783,69.783,69.783,69.783,0,0,0,69.783,69.781",
    transform: "translate(1507.646 -446.921)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorKyteTecState);
export default __webpack_public_path__ + "static/media/error-kyte-tec-state.ac49ae5fd00c76d39f48da9c4d7c1f26.svg";
export { ForwardRef as ReactComponent };